import { useEffect, useState } from 'react';

export const useCountdown = (endDate: string, getCurrentTime: () => number = () => Date.now()) => {
    const countdownDate = new Date(endDate).getTime();

    const [countDown, setCountDown] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCountDown(countdownDate - getCurrentTime());
        }, 1000);

        return () => clearInterval(timer);
    }, [countdownDate, getCurrentTime]);

    return getReturnValues(countDown);
};

const getReturnValues = (countDown: number) => {
    if (countDown <= 0) {
        return [0, 0, 0, 0];
    } else {
        const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
        const hours = Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

        return [days, hours, minutes, seconds];
    }
};
